<template>
  <div class="room data-history" v-loading="loading || initializeLoading">
    <div class="dh-column">
      <div class="dh-column-item">
        <div class="dh-label">
          <span>布局：</span>
          <el-select class="time-select" v-model="chartNumber" placeholder="请选择" :disabled="isHistoryScenario">
            <el-option label="1×1" :value="1"></el-option>
            <el-option label="2×2" :value="4"></el-option>
          </el-select>
        </div>
        <div class="dh-label" v-if="isHumidityPercentage">
          <span>截止日期：</span>
          <el-date-picker class="date-time" v-model="search_humidityPercentage.dataDate" type="datetime"
            placeholder="选择日期时间" :editable="false" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
            :disabled="isHistoryScenario"></el-date-picker>
        </div>
        <div class="dh-label" v-else>
          <span>截止日期：</span>
          <el-date-picker class="date-time" v-model="search.dataDate" type="datetime" placeholder="选择日期时间"
            :editable="false" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
            :disabled="isHistoryScenario"></el-date-picker>
        </div>
        <!-- <div class="dh-label" v-if="isHumidityPercentage">
          <span>湿度下限：</span>
          <el-input
            class="time-select"
            v-model="search_humidityPercentage.firstLine"
            type="number"
            placeholder="设定湿度下限"
            :disabled="isHistoryScenario"
          >
          </el-input>
        </div>
        <div class="dh-label" v-if="isHumidityPercentage">
          <span>湿度上限：</span>
          <el-input
            class="time-select"
            v-model="search_humidityPercentage.secondLine"
            type="number"
            placeholder="设定湿度上限"
            :disabled="isHistoryScenario"
          >
          </el-input>
        </div> -->
        <div class="dh-label" v-if="!isHumidityPercentage">
          <span>间隔类型：</span>
          <el-select class="time-select" v-model="search.interval" placeholder="请选择" :disabled="isHistoryScenario">
            <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dh-label" v-if="isHumidityPercentage">
          <span>统计天数：</span>
          <el-select class="time-select" v-model="search_humidityPercentage.daysCount" placeholder="请选择"
            :disabled="isHistoryScenario">
            <el-option v-for="item in numOptions_humidityPercentage" :key="item.value" :label="item.label"
              :value="item.value"> </el-option>
          </el-select>
        </div>
        <div class="dh-label" v-else>
          <span>数据数量：</span>
          <el-select class="time-select" v-model="search.count" placeholder="请选择" :disabled="isHistoryScenario">
            <el-option v-for="item in numOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dh-label" v-if="isAdmin && !isHistoryScenario">
          <el-button @click="historyScenarioDialogButton" plain :disabled="isHistoryScenario">创建历史场景</el-button>
        </div>
        <div class="dh-label" v-if="isAdmin && isHistoryScenario">
          <el-button @click="releaseHistoryScenarioLockButton" plain :disabled="!isHistoryScenario">解除参数锁定</el-button>
        </div>
        <!-- 历史场景名称 -->
        <div class="dh-label" v-if="historyScenarioName && historyScenarioName != ''">
          <span class="history-scenario-name">{{ historyScenarioName }}</span>
        </div>
      </div>
      <div class="dh-column-item">
        <div class="dh-label dh-right">
          <span>特定时间：</span>
          <el-switch v-model="search.specialHourXAxis" :disabled="isHistoryScenario"></el-switch>
        </div>
        <div class="dh-label dh-right">
          <span>去除0：</span>
          <el-switch v-model="search.removeZero" :disabled="isHistoryScenario"></el-switch>
        </div>
        <div class="dh-label dh-right">
          <span>温度轴：</span>
          <el-switch v-model="seperateTemperatureYAxis" :disabled="isHistoryScenario"></el-switch>
        </div>
        <div class="dh-label dh-right">
          <span>定时刷新：</span>
          <el-switch v-model="isSetTime" :disabled="isHistoryScenario"></el-switch>
        </div>
        <div class="dh-label dh-right">
          <span>填充缺失：</span>
          <el-switch v-model="search.insertBlankData" :disabled="isHistoryScenario"></el-switch>
        </div>
      </div>
    </div>
    <div class="dh-body-container">
      <!--历史场景侧边栏-->
      <div class="dh-history-scenario-select" v-if="isHistoryScenario">
        <el-menu :default-active="historyScenarioNavActiveIndex" :default-openeds="historyScenarioNavActiveGroup"
          @select="handleHistoryScenarioNavSelect">
          <el-submenu v-for="(historyScenarioNavGroup, i) in historyScenarioNavList"
            :key="historyScenarioNavGroup.groupName" :index="i + ''">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>{{ historyScenarioNavGroup.groupName }}</span>
            </template>
            <el-menu-item v-for="historyScenarioNavItem in historyScenarioNavGroup.navItemList"
              :key="historyScenarioNavItem.scenarioName" :index="historyScenarioNavItem.hrefUrl">
              {{ historyScenarioNavItem.scenarioName }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="dh-body">
        <div class="layout-chart" :class="{ 'layout-four': chartNumber > 1 }" v-for="number in chartNumber"
          :key="`chart-data${number}`">
          <history-block @resetSearchConfig="resetSearchConfig" @setSearchConfig="setSearchConfig"
            @setSearchConfigInterval="setSearchConfigInterval" @onBlankData="doChangeBlank" :chartNumber="chartNumber"
            :search="search" :search_humidityPercentage="search_humidityPercentage" :isTime="isSetTime"
            :seperateTemperatureYAxis="seperateTemperatureYAxis"
            v-on:setHumidityPercentage="setHumidityPercentageHandler" :ref="'historyBlock' + number"></history-block>
        </div>
      </div>
    </div>
    <!--历史场景弹窗-->
    <el-dialog width="620px" :visible.sync="historyScenarioDialogVisible" :show-close="false"
      :close-on-click-modal="false" :close-on-press-escape="false" v-loading="loading">
      <div class="dialog-title" slot="title">创建历史场景</div>
      <el-form :model="historyScenarioFormData" :rules="historyScenarioFormRules" ref="historyScenarioForm">
        <el-form-item label="场景名称" prop="scenarioName">
          <el-input v-model="historyScenarioFormData.scenarioName" placeholder="请输入场景名称"
            class="dialog-form-input"></el-input>
        </el-form-item>
        <el-form-item label="场景分组" prop="scenarioGroup">
          <el-select v-model="historyScenarioFormData.scenarioGroup" filterable allow-create placeholder="请选择或输入场景分组"
            class="dialog-form-input">
            <el-option v-for="currentGroupName in historyScenarioCurrentGroupNameList" :key="currentGroupName"
              :label="currentGroupName" :value="currentGroupName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场景桥梁">
          <span>{{ historyScenarioFormData.bridgeName }}</span>
        </el-form-item>
        <el-form-item label="配置长度">
          <span>{{ historyScenarioFormData.jsonLength }}</span>
        </el-form-item>
        <el-form-item label="窗口数量">
          <span>{{ historyScenarioFormData.historyBlockCount }}</span>
        </el-form-item>
        <el-form-item label="设备数量">
          <span>{{ historyScenarioFormData.deviceCount }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="historyScenarioDialogVisible = false">取消</el-button>
        <el-button @click="submitHistoryScenarioDialog" type="primary">确定</el-button>
      </div>

      <!--提交成功弹窗-->
      <el-dialog width="620px" :visible.sync="historyScenarioSuccessDialogVisible" :show-close="false"
        :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
        <div class="dialog-title" slot="title">创建成功</div>
        <span>创建历史场景成功: {{ this.historyScenarioFormData.scenarioName + "(" + this.historyScenarioFormData.scenarioGroup
          +
          ")" }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hrefHistoryScenarioControlPage">历史场景管理</el-button>
          <el-button @click="
            historyScenarioSuccessDialogVisible = false;
          historyScenarioDialogVisible = false;
          " type="primary">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>

    <!--权限失败弹窗-->
    <el-dialog width="620px" :visible.sync="accessDeniedDialogVisible" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" append-to-body>
      <div class="dialog-title" slot="title">权限不足</div>
      <span>您登录的用户没有自定义历史查询的权限. 请联系管理员.</span>
      <div slot="footer" class="dialog-footer-right">
        <el-button @click="hrefToHistoryAccessControlPage()" type="primary">权限申请</el-button>
        <el-button @click="hrefToBridgeHomePage()" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import HistoryBlock from "./HistoryBlock";
import { mapGetters } from "vuex";
import { historyDataCountOptions } from "../constants.js";

export default {
  name: "dataHistory",
  components: {
    HistoryBlock,
  },
  data() {
    return {
      chartNumber: 1,
      search: {
        interval: "BY_HOUR",
        count: 20,
        dataDate: "",
        insertBlankData: true,
        removeZero: false,
        specialHourXAxis: false,
      },
      search_humidityPercentage: {
        daysCount: 30,
        dataDate: "",
        firstLine: 50,
        secondLine: 60,
      },
      isSetTime: true,
      seperateTemperatureYAxis: false,
      dateOptions: [
        { label: "不使用", value: "NA" },
        { label: "每小时", value: "BY_HOUR" },
        { label: "每日", value: "BY_DAY" },
        // { label: "每周", value: "BY_WEEK" },
        { label: "每月", value: "BY_MONTH" },
      ],
      numOptions: [],
      // numOptions: [
      //   { label: 6, value: 6 },
      //   { label: 10, value: 10 },
      //   { label: 12, value: 12 },
      //   { label: 20, value: 20 },
      //   { label: 24, value: 24 },
      //   { label: 30, value: 30 },
      //   { label: 40, value: 40 },
      //   { label: 50, value: 50 },
      //   { label: 60, value: 60 },
      //   { label: 90, value: 90 },
      //   { label: 100, value: 100 },
      //   { label: 200, value: 200 },
      //   { label: 365, value: 365 },
      //   { label: 500, value: 500 },
      //   { label: 720, value: 720 },
      //   { label: 1000, value: 1000 },
      //   { label: 1440, value: 1440 },
      //   { label: 1500, value: 1500 },
      //   { label: 2000, value: 2000 },
      // ],
      numOptions_humidityPercentage: [
        { label: 28, value: 28 },
        { label: 30, value: 30 },
        { label: 31, value: 31 },
        { label: 60, value: 60 },
        { label: 90, value: 90 },
        { label: 120, value: 120 },
        { label: 150, value: 150 },
        { label: 180, value: 180 },
        { label: 210, value: 210 },
        { label: 240, value: 240 },
        { label: 270, value: 270 },
        { label: 300, value: 300 },
        { label: 330, value: 330 },
        { label: 365, value: 365 },
        { label: '雷达图(3)', value: 3 },
      ],
      timer: null,
      isHumidityPercentage: false,

      isHistoryScenario: true,
      loading: false,
      initializeLoading: true,
      historyScenarioDialogVisible: false,
      historyScenarioSuccessDialogVisible: false,
      historyScenarioFormData: {
        scenarioName: "",
        scenarioGroup: "默认场景",
        bridgeName: "",
        bridgeId: "",
        deviceCount: 0,
        historyBlockCount: 0,
        jsonLength: 0,
      },
      historyScenarioModel: null,
      historyScenarioFormRules: {
        scenarioName: [{ required: true, message: "请输入场景名称", trigger: "blur" }],
        scenarioGroup: [{ required: true, message: "请输入场景分组", trigger: "blur" }],
      },
      historyScenarioName: undefined,
      historyScenarioCurrentGroupNameList: [],

      historyScenarioNavList: [],
      historyScenarioNavActiveIndex: "",
      historyScenarioNavActiveGroup: ["0"],

      isStatisticsAccessApproved: false,
      isStatisticsRetrictedBridge: true,
      accessDeniedDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  watch: {
    "search.insertBlankData"(val) {
      this.checkSearchParameter();
      // if (!val && this.search.interval !== "NA") {
      //   const $index = this.$children.findIndex((val) => val.HistoryBlock && val.resultIdList.length > 1);
      //   if ($index > -1) {
      //     this.$message({
      //       message: "当选择多个数据时，必须启用本开关以确保数据处于正确时间位置",
      //       type: "warning",
      //     });
      //     this.search.insertBlankData = true;
      //   }
      // }

      // if (val && this.search.interval === "NA") {
      //   this.$message({
      //     message: "无间隔数据无法填充空白数据。",
      //     type: "warning",
      //   });
      //   this.search.insertBlankData = false;
      // }
    },
    "search.interval"(val) {
      this.checkSearchParameter();
      // if (val === "NA") {
      //   const $index = this.$children.findIndex((val) => val.HistoryBlock && val.resultIdList.length > 1);
      //   if ($index > -1) {
      //     this.$message({
      //       message: "无法同时展示多个数据的原始值曲线。请选择单一设备或使用统计间隔",
      //       type: "warning",
      //     });
      //     this.search.interval = "BY_HOUR";
      //   }
      // }
    },
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.initializeLoading = true;
      this.isStatisticsRetrictedBridge = true;
      this.isStatisticsAccessApproved = false;
      let oldIsHistoryScenario = this.isHistoryScenario;
      this.setIsHistoryScenario();

      //clear all history block and release button locks
      if (oldIsHistoryScenario && !this.isHistoryScenario) {
        this.setEmptyHistoryScenario();
        this.releaseHistoryScenarioLockButton();
      }

      this.initializeCustomStatisticsAuth();

      if (this.isHistoryScenario) {
        this.initializeHistoryScenario();
      }
    },
  },
  mounted() {
    this.checkAuth();
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);

    this.setIsHistoryScenario();
    this.initializeCustomStatisticsAuth();

    this.numOptions = historyDataCountOptions;

    if (this.isHistoryScenario) {
      this.initializeHistoryScenario();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkSearchParameter() {
      const $index = this.$children.findIndex((val) => val.HistoryBlock && val.resultIdList.length > 1);
      if ($index > -1 && this.search.interval !== "NA" && !this.search.insertBlankData) {
        //选择了多个设备, 必须填充缺失数据. (不使用统计间隔除外)
        this.$message({
          message: "当选择多个数据时，必须启用填充缺失数据以确保时间正确对齐",
          type: "warning",
        });
        this.search.insertBlankData = true;
      }

      if (this.search.interval === "NA" && this.search.insertBlankData) {
        //不使用统计间隔, 无法填充缺失数据.
        this.$message({
          message: "不使用统计间隔时, 无法填充缺失数据",
          type: "warning",
        });
        this.search.insertBlankData = false;
      }
    },
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => { });
    },
    /**
     * 设备大于1 强制  填充缺失数据数据为true
     */
    doChangeBlank() {
      this.search.insertBlankData = true;

      this.$message({
        message: "当选择多个数据时，必须启用填充缺失数据以确保时间正确对齐",
        type: "warning",
      });

      // this.search.interval = "BY_HOUR"
      // this.search.insertBlankData = false;
    },
    hrefToHistoryAccessControlPage() {
      this.$router.push("/admin/historyAccessControl");
    },
    hrefToBridgeHomePage() {
      let fullPath = this.$route.fullPath;
      let dataHistoryIndex = fullPath.indexOf("/dataHistory");
      if (dataHistoryIndex && dataHistoryIndex > 0) {
        let hrefPath = fullPath.slice(0, dataHistoryIndex);
        hrefPath = hrefPath + "Index";
        this.$router.push(hrefPath);
      }
    },
    initializeCustomStatisticsAuth() {
      let bridgeId = this.$route.query.bridgeId;
      if (bridgeId) {
        //check bridge statistics restricted and user statistics approved
        let urlList = [this.$http.get("/bridge/BridgeInfo?bridgeId=" + bridgeId), this.$http.get("/statisticsAccess/IsStatisticsAccessApproved")];
        this.$http.all(urlList).then(
          this.$http.spread((resBridge, resUser) => {
            this.isStatisticsRetrictedBridge = resBridge.data.isStatisticsAccessRestricted;
            this.isStatisticsAccessApproved = resUser.data.statisticsAccessApproved;

            console.log(
              "check statistics access: " +
              resUser.data.statisticsAccessApproved +
              ", bridge restricted: " +
              resBridge.data.isStatisticsAccessRestricted
            );

            this.checkAuthAndReleaseInitializeLoading();
          })
        );
      } else {
        //no bridge id in url
        this.$http.get("/statisticsAccess/IsStatisticsAccessApproved").then((res) => {
          this.isStatisticsAccessApproved = res.data.statisticsAccessApproved;
          console.log("check statistics access: " + res.data.statisticsAccessApproved);

          this.checkAuthAndReleaseInitializeLoading();
        });
      }
    },
    checkAuthAndReleaseInitializeLoading() {
      //pass value to history blocks
      for (let i = 1; i <= 4; i++) {
        //chart number index start from 1, history block list index start from 0
        let historyBlock = this.$refs["historyBlock" + i] ? this.$refs["historyBlock" + i][0] : undefined;

        if (historyBlock) {
          historyBlock.setIsStatisticsAccessApproved(this.isStatisticsAccessApproved);
        }
      }

      if (!this.isStatisticsRetrictedBridge) {
        this.initializeLoading = false;
        return;
      }

      if (this.isStatisticsAccessApproved || this.isHistoryScenario || this.isAdmin) {
        this.initializeLoading = false;
      } else {
        this.accessDeniedDialogVisible = true;
      }
    },
    setIsHistoryScenario() {
      let scenarioId = this.$route.query.scenarioId;
      let bridgeId = this.$route.query.bridgeId;
      if (!scenarioId || scenarioId === "" || !bridgeId || bridgeId === "") {
        this.isHistoryScenario = false;
      } else {
        this.isHistoryScenario = true;
      }
    },
    initializeHistoryScenario() {
      this.historyScenarioName = "";
      let scenarioId = this.$route.query.scenarioId;
      if (!this.isHistoryScenario) {
        return;
      }

      this.loading = true;

      this.historyScenarioNavActiveIndex = this.$route.fullPath;
      this.initializeHistoryScenarioNav();

      if (scenarioId.toLowerCase() === "tbd") {
        this.setEmptyHistoryScenario();
        this.$nextTick(() => {
          this.loading = false;
          if (this.initializeLoading) {
            this.initializeLoading = false;
          }
        });
        return;
      }

      let url = "/historyScenario/GetHistoryScenarioByScenarioId?scenarioId=" + scenarioId;
      this.$http
        .get(url)
        .then((res) => {
          let serverScenario = res.data;
          let historyScenario = JSON.parse(serverScenario.scenarioJson);
          let deviceIdList = serverScenario.scenarioDeviceIdList;
          this.historyScenarioName = serverScenario.scenarioName;

          if (this.initializeLoading) {
            this.initializeLoading = false;
          }

          this.setHistoryScenario(historyScenario, deviceIdList);
          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: "加载历史场景失败. 请刷新页面重试, 或联系管理员. " + err,
            type: "warning",
          });
          this.loading = false;
        });
    },
    initializeHistoryScenarioNav() {
      let bridgeId = this.$route.query.bridgeId;
      let authBridge = this.bridgeList.filter((item) => item.id === bridgeId)[0];
      if (!bridgeId || !authBridge) {
        this.$message({
          message: "桥梁编号错误. 历史场景列表加载失败. 请返回主页重试.",
          type: "warning",
        });
        return;
      }

      this.historyScenarioNavActiveGroup = [];
      let isTBDPage = false;
      let scenarioId = this.$route.query.scenarioId;
      if (scenarioId && scenarioId.toLowerCase() === "tbd") {
        isTBDPage = true;
      }

      let url = "/historyScenario/GetHistoryScenarioList?bridgeId=" + bridgeId + "&start=0&limit=999";
      this.$http
        .get(url)
        .then((res) => {
          let scenarioList = res.data;
          if (scenarioList.length === 0)
            scenarioList.push({
              scenarioName: "(暂无历史场景, 请联系管理员)",
              scenarioGroup: "默认分组",
              scenarioId: "TBD",
            });

          let result = [];
          for (let scenario of scenarioList) {
            let groupName = scenario.scenarioGroup;
            let currentGroup = result.filter((item) => item.groupName === groupName)[0];

            scenario.hrefUrl = this.$route.path + "?bridgeId=" + bridgeId + "&scenarioId=" + scenario.scenarioId;

            if (!currentGroup) {
              result.push({ groupName: groupName, navItemList: [scenario] });
            } else {
              currentGroup.navItemList.push(scenario);
            }
          }

          this.historyScenarioNavList = result;
          if (isTBDPage) {
            this.historyScenarioNavActiveGroup = ["0"];
          } else {
            let groupIndex = 0;
            let activeGroup = -1;
            for (let scenarioGroup of result) {
              for (let scenario of scenarioGroup.navItemList) {
                if (scenario.hrefUrl === this.$route.fullPath) {
                  activeGroup = groupIndex;
                }
              }
              groupIndex++;
            }

            if (activeGroup >= 0) {
              this.historyScenarioNavActiveGroup = [activeGroup + ""];
            }
          }
        })
        .catch((err) => {
          this.$message({
            message: "查询失败. 历史场景列表加载失败. 请返回主页重试. ",
            type: "warning",
          });
        });
    },
    handleHistoryScenarioNavSelect(key) {
      if (key !== this.historyScenarioNavActiveIndex) {
        this.historyScenarioNavActiveIndex = key;
        this.$router.push(key);
      }
    },
    historyScenarioDialogButton() {
      this.historyScenarioModel = undefined;
      this.loading = true;
      try {
        this.historyScenarioModel = this.getHistoryScenario();
      } catch (err) {
        this.$alert(err, {
          confirmButtonText: "确定",
          showClose: false,
          type: "error",
          callback: (action) => {
            // this.resultObjectList = [];
          },
        });

        return;
      }

      let bridgeName = undefined;
      for (let bridge of this.bridgeList) {
        if (bridge.id === this.historyScenarioModel.bridgeId) {
          bridgeName = bridge.name;
          break;
        }
      }
      this.historyScenarioFormData.scenarioName = "";
      this.historyScenarioFormData.scenarioGroup = "默认分组";
      this.historyScenarioFormData.bridgeName = bridgeName;
      this.historyScenarioFormData.bridgeId = this.historyScenarioModel.bridgeId;
      this.historyScenarioFormData.deviceCount = this.historyScenarioModel.deviceIdList.length;
      this.historyScenarioFormData.historyBlockCount = this.chartNumber;

      let fakeScenarioModel = JSON.parse(JSON.stringify(this.historyScenarioModel));
      delete fakeScenarioModel.bridgeId;
      delete fakeScenarioModel.deviceIdList;
      this.historyScenarioFormData.jsonLength = JSON.stringify(fakeScenarioModel).length;

      let url = "/historyScenario/GetHistoryScenarioList?bridgeId=" + this.historyScenarioFormData.bridgeId + "&start=0&limit=999";
      this.$http
        .get(url)
        .then((res) => {
          let scenarioList = res.data;
          this.historyScenarioCurrentGroupNameList = [];
          for (let scenario of scenarioList) {
            let groupName = scenario.scenarioGroup;
            if (this.historyScenarioCurrentGroupNameList.indexOf(groupName) < 0) {
              this.historyScenarioCurrentGroupNameList.push(groupName);
            }
          }

          this.historyScenarioDialogVisible = true;
          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: "当前历史场景分组查询失败. ",
            type: "warning",
          });
          console.log(err);
          this.loading = false;
        });
    },
    submitHistoryScenarioDialog() {
      this.$refs.historyScenarioForm.validate().then(() => {
        let postBody = {
          scenarioName: this.historyScenarioFormData.scenarioName,
          scenarioBridgeId: this.historyScenarioModel.bridgeId,
          scenarioDeviceIdList: this.historyScenarioModel.deviceIdList,
          scenarioGroup: this.historyScenarioFormData.scenarioGroup,
        };

        delete this.historyScenarioModel.bridgeId;
        delete this.historyScenarioModel.deviceIdList;
        postBody.scenarioJson = JSON.stringify(this.historyScenarioModel);

        this.loading = true;
        this.$http
          .post("/historyScenario/InsertHistoryScenario", postBody)
          .then(() => {
            this.historyScenarioSuccessDialogVisible = true;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    releaseHistoryScenarioLockButton() {
      this.isHistoryScenario = false;
      this.historyScenarioName = "";

      for (let i = 1; i <= 4; i++) {
        //chart number index start from 1, history block list index start from 0
        let historyBlock = this.$refs["historyBlock" + i] ? this.$refs["historyBlock" + i][0] : undefined;

        if (historyBlock) {
          historyBlock.releaseHistoryScenario();
        }
      }
    },
    hrefHistoryScenarioControlPage() {
      this.$router.push("/admin/historyScenarioControl?bridgeId=" + this.historyScenarioFormData.bridgeId);
    },
    setHistoryScenario(historyScenarioModel, deviceIdList) {
      this.chartNumber = historyScenarioModel.chartNumber;
      this.search = historyScenarioModel.search;
      this.search_humidityPercentage = historyScenarioModel.search_humidityPercentage;
      this.seperateTemperatureYAxis = historyScenarioModel.seperateTemperatureYAxis;

      this.$nextTick(() => {
        for (let i = 1; i <= 4; i++) {
          //chart number index start from 1, history block list index start from 0
          let historyBlock = this.$refs["historyBlock" + i] ? this.$refs["historyBlock" + i][0] : undefined;
          let historyBlockScenario = historyScenarioModel.historyBlockList[i - 1];

          if (historyBlock && historyBlockScenario) {
            historyBlock.setHistoryScenario(historyBlockScenario, deviceIdList);
          }
        }
      });
    },
    setEmptyHistoryScenario() {
      for (let i = 1; i <= 4; i++) {
        //chart number index start from 1, history block list index start from 0
        let historyBlock = this.$refs["historyBlock" + i] ? this.$refs["historyBlock" + i][0] : undefined;

        if (historyBlock) {
          historyBlock.setEmptyHistoryScenario();
        }
      }
    },
    getHistoryScenario() {
      let historyScenarioModel = {};
      historyScenarioModel.chartNumber = this.chartNumber;
      historyScenarioModel.search = this.search;
      historyScenarioModel.search_humidityPercentage = this.search_humidityPercentage;
      historyScenarioModel.seperateTemperatureYAxis = this.seperateTemperatureYAxis;

      let historyBlockList = [];
      for (let i = 1; i <= 4; i++) {
        let historyBlock = this.$refs["historyBlock" + i] ? this.$refs["historyBlock" + i][0] : undefined;
        if (historyBlock) {
          historyBlockList.push(historyBlock.getHistoryScenario());
        }
      }

      let bridgeId = undefined;
      let deviceIdList = [];
      for (let historyBlock of historyBlockList) {
        deviceIdList.push(...historyBlock.deviceIdList);

        for (let bridgeIdItem of historyBlock.bridgeIdList) {
          if (!bridgeId) {
            bridgeId = bridgeIdItem;
          } else {
            if (bridgeId != bridgeIdItem) {
              throw "当前所选设备分属多座桥梁. 请重新选择.";
            }
          }
        }

        delete historyBlock.bridgeIdList;
        delete historyBlock.deviceIdList;
      }

      if (deviceIdList.length === 0 || !bridgeId) {
        throw "所选设备为空";
      }

      historyScenarioModel.historyBlockList = historyBlockList;
      historyScenarioModel.bridgeId = bridgeId;
      historyScenarioModel.deviceIdList = deviceIdList;
      return historyScenarioModel;
    },
    resetSearchConfig() {
      this.chartNumber = 1;
      this.search = {
        interval: "BY_HOUR",
        count: 20,
        dataDate: "",
        insertBlankData: false,
      };
    },
    setHumidityPercentageHandler(value) {
      this.isHumidityPercentage = value;
    },
    setSearchConfig(searchOption) {
      this.chartNumber = 1;
      this.search = searchOption;
      // this.search = {
      //   interval: 'BY_HOUR',
      //   count: 744,
      //   dataDate: dataDate,
      //   insertBlankData: true
      // }
    },
    setSearchConfigInterval(interval) {
      this.search.interval = interval;
    },
  },
};
</script>
<style lang="scss">
.data-history {
  .tree-node {
    .el-checkbox {
      font-weight: normal;
    }
  }
}
</style>
<style lang='scss' scoped>
.no-device {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 32px;
    color: #aaa;
    letter-spacing: 2px;
  }
}

.date-time {
  width: 190px;
}

.dialog-title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;

  span {
    font-size: 12px;
    color: #606266;
    margin-left: 6px;
  }
}

.el-table th,
.el-table td {
  text-align: center;
}

.dialog-footer {
  text-align: right;
  margin-right: 30px;
}

.dialog-footer-right {
  text-align: right;
  margin-right: 00px;
}

.dh-label {
  color: #606266;
  font-size: 14px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.dh-right {
  margin-top: 14px;
}

.dh-column {
  padding: 10px 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  justify-content: space-between;

  .dh-column-item {
    display: flex;
    align-items: center;
  }
}

.dh-warp-column {
  padding: 10px 20px;
}

.time-select {
  width: 100px;
}

.dh-warp {
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.layout-chart {
  width: 100%;
  height: 100%;
}

.dh-body-container {
  height: calc(100% - 90px);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
}

.dh-history-scenario-select {
  margin-right: 15px;
  background-color: #ffffff;
  width: 20%;
  height: 100%;

  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}


.dh-body {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;

  .layout-four {
    width: calc(50% - 4px);
    height: calc(50% - 4px);
  }
}

.data-history {
  padding-top: 10px;
}

.dialog-form-input {
  width: 80%;
}

.history-scenario-name {
  font-weight: bold;
}
</style>
